import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ADD_GROUP = 'add group'
export const NAME = 'name'
export const CLIENT_ID = 'CLIENT_ID'
export const RATE_CARD = 'rate card'
export const REQUIRED_FIELDS = 'required fields'
export const GROUP_REGISTERED = 'group registered'

export default {
  [PORTUGUESE]: {
    [ADD_GROUP]: 'Adicionar Grupo',
    [NAME]: 'Nome',
    [CLIENT_ID]: 'Id do Cliente',
    [RATE_CARD]: 'Tabela de Preços',
    [REQUIRED_FIELDS]: 'Por favor preencha os campos obrigatórios',
    [GROUP_REGISTERED]: 'Grupo registrado com sucesso',
  },

  [ENGLISH]: {
    [ADD_GROUP]: 'Add Group',
    [NAME]: 'Name',
    [CLIENT_ID]: 'Client Id',
    [RATE_CARD]: 'Rate Card',
    [REQUIRED_FIELDS]: 'Please fill in the required fields',
    [GROUP_REGISTERED]: 'Group registered successfully',
  },

  [SPANISH]: {
    [ADD_GROUP]: 'Añadir Grupo',
    [NAME]: 'Nombre',
    [CLIENT_ID]: 'Identificación del Cliente',
    [RATE_CARD]: 'Tarjeta de Tarifa',
    [REQUIRED_FIELDS]: 'Por favor llene los campos requeridos',
    [GROUP_REGISTERED]: 'Grupo registrado con éxito',
  },
}
